import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NestedPopupService } from 'src/app/services/UI/nested-popup.service';
import { Observable, Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class PlacemanagementService extends NestedPopupService {

  constructor() {
    super()


  }
}
